import { Injectable, inject } from '@angular/core';
import { Location, LocationsService } from '@era/inroom-sdk';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocationsApi {
  private readonly locationService = inject(LocationsService);

  public getLocations(): Observable<Location[]> {
    return this.locationService.getLocations();
  }

  public addLocation(location: Location): Observable<Location> {
    return this.locationService.addLocation({ location });
  }

  public deleteLocation(location: Location): Observable<unknown> {
    return this.locationService.deleteLocation({ hotelCode: location.HotelCode });
  }
}
